import apiAxios from "../../apiAxios";

export default async function tickParticipantVisit(
  visitId: number
): Promise<void> {
  await apiAxios.put(`/a/visit/${visitId}`);
}
